module.exports = "/dist/img/giftshopper_sample2.14543935.jpg";